/**
 * systemNoticeRouterModule 系统公告路由
 */
"use strict";
angular.module('systemNoticeRouterModule', []).
config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("manageconfig.sysmanage.systemnotice.editnotice", { //系统公告编辑
        url: '/editnotice?noticeid',
        views: {
            'main@manageconfig.sysmanage': {
                templateUrl: './manageConfig/sysManageMent/systemNotice/editNotice/editNotice_tpl.html',
                controller: 'editNoticeCtrl'
            }
        }
    }).state("systemnoticedetail", {
        url: "/systemnoticedetail?noticeid",
        views: {
            "": {
                templateUrl: "./manageConfig/sysManageMent/systemNotice/noticeDetail/noticeDetail_tpl.html",
                controller: "noticeDetailCtrl"
            }
        }
    });
}]);